<mat-dialog-content class="modal-content" style="padding-left: 30px; padding-right: 30px">
  <h2 class="modal-title text-black">Update Monthly Costs</h2>

  <!-- Skeleton Loader -->
  <div *ngIf="isLoading" class="loading-skeleton">
    <div *ngFor="let _ of [1, 2, 3, 4]; trackBy: trackByDriverId" class="skeleton-driver-card">
      <div class="skeleton-title"></div>
      <div class="skeleton-field"></div>
      <div class="skeleton-field"></div>
      <div class="skeleton-field"></div>
      <div class="skeleton-field"></div>
    </div>
  </div>
  <div *ngIf="!isLoading">
    <div
      *ngFor="let driver of drivers; let i = index; trackBy: trackByDriverId"
      class="font-inter driver-card text-black"
      style="border-bottom: 1px solid #92a0ad"
    >
      <h3 class="font-inter driver-name text-black">{{ driver.name }}</h3>
      <div class="driver-fields">
        <mat-form-field appearance="fill" class="field">
          <mat-label>Pay Type*</mat-label>
          <mat-select [(value)]="driver.payType">
            <mat-option value="% Of Load">% Of Load</mat-option>
            <mat-option value="Month">Month</mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container *ngIf="driver.payType === '% Of Load'; else monthlyPay">
          <mat-form-field appearance="fill" class="field">
            <mat-label>Percent of Gross*</mat-label>
            <input matInput type="number" [(ngModel)]="driver.percentGross" />
            <span matSuffix>%</span>
          </mat-form-field>
        </ng-container>

        <ng-template #monthlyPay>
          <mat-form-field appearance="fill" class="field">
            <mat-label>Pay Per Month*</mat-label>
            <input matInput type="number" [(ngModel)]="driver.payPerMonth" />
            <span matSuffix>/month</span>
          </mat-form-field>
        </ng-template>

        <div class="insurance-cell">
          <mat-form-field appearance="fill" class="field insurance-field">
            <mat-label>Insurance*</mat-label>
            <input matInput type="number" [(ngModel)]="driver.insurance" />
            <span matSuffix>/month</span>
          </mat-form-field>
          <button mat-button class="copy-button" (click)="copyInsuranceToAll(i)">Copy To All</button>
        </div>

        <mat-form-field appearance="fill" class="field">
          <mat-label>Maintenance Cost*</mat-label>
          <input matInput type="number" [(ngModel)]="driver.maintenanceCost" />
          <span matSuffix>/mile</span>
        </mat-form-field>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-actions" style="background: transparent">
  <button mat-button (click)="onCancel()" style="color: #000000">Cancel</button>

  <button mat-raised-button color="primary" (click)="onUpdate()">
    <div class="button-content">
      <mat-spinner *ngIf="isLoading" diameter="20" color="accent"></mat-spinner>
      <span>Update Costs</span>
    </div>
  </button>
</mat-dialog-actions>
